/* Alba Stella - Impulse-style product pages (owner Q-NL).
   Gallery (adaptive height, vertical thumbs, dots, zoom), sold-out styling of option buttons, quantity +/-,
   size-guide dialog, "Recent bekeken". Works for the main product section and for the quick view
   (the quick view's stylesheet onload calls AlbaPdpi.scan() or loads this file).
   Add to cart, prices and variant ids stay with window.Alba.initProductMain (alba-theme.js). */
(function () {
  'use strict';
  if (window.AlbaPdpi) { window.AlbaPdpi.scan(); return; }

  var doc = document;
  var qs = function (s, c) { return (c || doc).querySelector(s); };
  var qsa = function (s, c) { return Array.prototype.slice.call((c || doc).querySelectorAll(s)); };
  var desktop = window.matchMedia('(min-width: 769px)');
  var ICON_CLOSE = '<svg class="pdpi-icon" viewBox="0 0 64 64" aria-hidden="true" focusable="false"><path d="M15 15l34 34M49 15 15 49" fill="none" stroke="currentColor" stroke-width="2.6" stroke-linecap="round"/></svg>';
  var ICON_PREV = '<svg class="pdpi-icon" viewBox="0 0 16 28" aria-hidden="true" focusable="false"><path d="M14.4 1.6 2 14l12.4 12.4" fill="none" stroke="currentColor" stroke-width="2"/></svg>';
  var ICON_NEXT = '<svg class="pdpi-icon" viewBox="0 0 16 28" aria-hidden="true" focusable="false"><path d="M1.6 1.6 14 14 1.6 26.4" fill="none" stroke="currentColor" stroke-width="2"/></svg>';

  function productData(root) {
    if (root.__pdpiData !== undefined) return root.__pdpiData;
    var el = qs('[data-product-json]', root);
    try { root.__pdpiData = el ? JSON.parse(el.textContent) : null; } catch (e) { root.__pdpiData = null; }
    return root.__pdpiData;
  }

  /* ---------- Scroll lock for our own layers ---------- */
  var locks = 0;
  function lock() { locks++; doc.documentElement.classList.add('pdpi-locked'); }
  function unlock() { locks = Math.max(0, locks - 1); if (!locks) doc.documentElement.classList.remove('pdpi-locked'); }

  /* ---------- Gallery ---------- */
  function initGallery(root) {
    var gal = qs('[data-pdpi-gallery]', root);
    if (!gal || gal.__pdpi) return;
    gal.__pdpi = true;
    var track = qs('[data-pdpi-track]', gal);
    if (!track) return;
    var slides = qsa('.pdpi-slide', track);
    var thumbs = qsa('[data-thumb]', gal);
    var dots = qsa('[data-pdpi-dot]', gal);
    var thumbsWrap = qs('[data-pdpi-thumbs]', gal);
    var scroller = qs('[data-pdpi-thumbs-scroller]', gal);
    var current = -1;
    var settleTimer = null;

    function fitHeight() {
      var s = slides[current];
      if (!s) return;
      var h = s.getBoundingClientRect().height;
      if (h) track.style.height = Math.round(h * 100) / 100 + 'px';
    }
    function checkThumbs() {
      if (thumbsWrap && scroller) thumbsWrap.classList.toggle('is-scrollable', scroller.scrollHeight > scroller.clientHeight + 2);
    }
    function setActive(i) {
      if (i < 0 || i >= slides.length) return;
      var changed = i !== current;
      current = i;
      slides.forEach(function (s, k) { s.classList.toggle('is-active', k === i); });
      thumbs.forEach(function (t, k) { t.classList.toggle('is-active', k === i); });
      dots.forEach(function (d, k) { d.classList.toggle('is-active', k === i); });
      fitHeight();
      if (changed) {
        var t = thumbs[i];
        if (t && scroller && desktop.matches) scroller.scrollTo({ top: Math.max(0, t.offsetTop), behavior: 'smooth' });
        slides.forEach(function (s, k) { if (k !== i) { var v = qs('video', s); if (v && !v.paused) { try { v.pause(); } catch (e) {} } } });
      }
    }
    function indexFromScroll() {
      var w = track.clientWidth || 1;
      return Math.max(0, Math.min(slides.length - 1, Math.round(track.scrollLeft / w)));
    }
    function go(i, smooth) {
      var n = slides.length;
      if (!n) return;
      i = ((i % n) + n) % n;
      track.scrollTo({ left: slides[i].offsetLeft, behavior: smooth === false ? 'auto' : 'smooth' });
      setActive(i);
    }
    gal.__pdpiGo = go;

    function settle() { setActive(indexFromScroll()); }
    track.addEventListener('scroll', function () {
      clearTimeout(settleTimer);
      settleTimer = setTimeout(settle, 90);
    }, { passive: true });
    if ('onscrollend' in window) track.addEventListener('scrollend', function () { clearTimeout(settleTimer); settle(); });

    thumbs.forEach(function (t) {
      t.addEventListener('click', function () { setActive(parseInt(t.getAttribute('data-thumb'), 10) || 0); });
    });
    dots.forEach(function (d) {
      d.addEventListener('click', function () { go(parseInt(d.getAttribute('data-pdpi-dot'), 10) || 0); });
    });
    qsa('[data-pdpi-step]', gal).forEach(function (b) {
      b.addEventListener('click', function () { go(current + (parseInt(b.getAttribute('data-pdpi-step'), 10) || 0)); });
    });
    track.addEventListener('transitionend', checkThumbs);
    gal.addEventListener('click', function (e) {
      var z = e.target.closest('[data-pdpi-zoom]');
      if (!z) return;
      e.preventDefault();
      openLightbox(slides, parseInt(z.getAttribute('data-pdpi-zoom'), 10) || 0);
    });

    var start = parseInt(gal.getAttribute('data-start'), 10) || 0;
    if (start > 0 && slides[start]) { track.scrollLeft = slides[start].offsetLeft; }
    setActive(start);
    checkThumbs();
    var lastW = track.clientWidth;
    var onResize = function () {
      fitHeight();
      checkThumbs();
      if (track.clientWidth !== lastW) {
        lastW = track.clientWidth;
        if (current >= 0 && slides[current]) track.scrollLeft = slides[current].offsetLeft;
      }
    };
    if (window.ResizeObserver) { new ResizeObserver(function () { onResize(); }).observe(gal); }
    else { window.addEventListener('resize', onResize); }
  }

  /* ---------- Lightbox ---------- */
  var lb = null;
  function closeLightbox() {
    if (!lb) return;
    lb.parentNode && lb.parentNode.removeChild(lb);
    var opener = lb.__opener; lb = null; unlock();
    if (opener && opener.focus) { try { opener.focus({ preventScroll: true }); } catch (e) {} }
  }
  function openLightbox(slides, index) {
    var items = slides.filter(function (s) { return s.hasAttribute('data-zoom-src'); });
    if (!items.length) return;
    closeLightbox();
    var start = Math.max(0, items.indexOf(slides[index]));
    lb = doc.createElement('div');
    lb.className = 'pdpi-lb';
    lb.setAttribute('role', 'dialog');
    lb.setAttribute('aria-modal', 'true');
    lb.setAttribute('aria-label', 'Productafbeeldingen');
    lb.__opener = doc.activeElement;
    var html = '<div class="pdpi-lb__track">';
    items.forEach(function (s) {
      var img = qs('img', s);
      var alt = img ? (img.getAttribute('alt') || '') : '';
      html += '<div class="pdpi-lb__slide"><img src="' + s.getAttribute('data-zoom-src') + '" alt="' + alt.replace(/"/g, '&quot;') + '" loading="lazy" decoding="async"></div>';
    });
    html += '</div><button type="button" class="pdpi-lb__btn pdpi-lb__btn--close" data-pdpi-lb-close aria-label="Sluiten">' + ICON_CLOSE + '</button>';
    if (items.length > 1) {
      html += '<button type="button" class="pdpi-lb__btn pdpi-lb__btn--prev" data-pdpi-lb-step="-1" aria-label="Vorige afbeelding">' + ICON_PREV + '</button>' +
              '<button type="button" class="pdpi-lb__btn pdpi-lb__btn--next" data-pdpi-lb-step="1" aria-label="Volgende afbeelding">' + ICON_NEXT + '</button>';
    }
    lb.innerHTML = html;
    doc.body.appendChild(lb);
    lock();
    var t = qs('.pdpi-lb__track', lb);
    t.scrollLeft = start * t.clientWidth;
    var first = qsa('img', t)[start];
    if (first) first.loading = 'eager';
    lb.addEventListener('click', function (e) {
      if (e.target.closest('[data-pdpi-lb-close]')) { closeLightbox(); return; }
      var step = e.target.closest('[data-pdpi-lb-step]');
      if (step) {
        var n = items.length, w = t.clientWidth || 1;
        var i = Math.round(t.scrollLeft / w) + (parseInt(step.getAttribute('data-pdpi-lb-step'), 10) || 0);
        i = ((i % n) + n) % n;
        t.scrollTo({ left: i * w, behavior: 'smooth' });
        return;
      }
      if (e.target.classList.contains('pdpi-lb__slide')) closeLightbox();
    });
    var closeBtn = qs('[data-pdpi-lb-close]', lb);
    if (closeBtn) { try { closeBtn.focus({ preventScroll: true }); } catch (e) {} }
  }

  /* ---------- Option availability (Impulse logic: each option against the options chosen before it) ---------- */
  function updateAvailability(root) {
    var data = productData(root);
    if (!data || !data.variants) return;
    var wraps = qsa('[data-option-index]', root);
    var sel = wraps.map(function (w) { var c = qs('input:checked', w); return c ? c.value : null; });
    wraps.forEach(function (w, i) {
      qsa('[data-option-input]', w).forEach(function (input) {
        var val = input.value, ok = false;
        for (var k = 0; k < data.variants.length && !ok; k++) {
          var v = data.variants[k];
          if (!v.available || v.options[i] !== val) continue;
          var match = true;
          for (var j = 0; j < i; j++) { if (v.options[j] !== sel[j]) { match = false; break; } }
          if (match) ok = true;
        }
        var label = input.nextElementSibling;
        if (label) label.classList.toggle('is-disabled', !ok);
      });
    });
  }

  function variantMediaIndex(root) {
    var data = productData(root);
    if (!data) return -1;
    var wraps = qsa('[data-option-index]', root);
    var sel = wraps.map(function (w) { var c = qs('input:checked', w); return c ? c.value : null; });
    var v = null;
    for (var k = 0; k < data.variants.length; k++) {
      var ok = true;
      for (var j = 0; j < sel.length; j++) { if (sel[j] != null && data.variants[k].options[j] !== sel[j]) { ok = false; break; } }
      if (ok) { v = data.variants[k]; break; }
    }
    if (!v || !v.media) return -1;
    var slide = qs('[data-media-position="' + v.media + '"]', root);
    return slide ? parseInt(slide.getAttribute('data-slide'), 10) : -1;
  }

  doc.addEventListener('change', function (e) {
    var t = e.target;
    if (t.matches && t.matches('[data-option-input]')) {
      var root = t.closest('[data-pdpi]');
      if (!root) return;
      updateAvailability(root);
      var i = variantMediaIndex(root);
      var gal = qs('[data-pdpi-gallery]', root);
      if (i >= 0 && gal && gal.__pdpiGo) gal.__pdpiGo(i);
    }
    if (t.matches && t.matches('.pdpi-qty__input')) {
      var n = parseInt(t.value, 10);
      if (!n || n < 1) t.value = 1; else if (n > 99) t.value = 99; else t.value = n;
    }
  });

  /* ---------- Quantity +/- ---------- */
  doc.addEventListener('click', function (e) {
    var b = e.target.closest('[data-pdpi-qty-step]');
    if (!b) return;
    e.preventDefault();
    var box = b.closest('[data-pdpi-qty]');
    var input = box && qs('input', box);
    if (!input) return;
    var v = (parseInt(input.value, 10) || 1) + (parseInt(b.getAttribute('data-pdpi-qty-step'), 10) || 0);
    input.value = Math.max(1, Math.min(99, v));
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  /* ---------- Size guide dialog ---------- */
  function openDialog(d, opener) {
    if (!d || !d.hidden) return;
    d.hidden = false;
    d.__opener = opener;
    lock();
    var c = qs('[data-pdpi-sg-close]', d);
    if (c) { try { c.focus({ preventScroll: true }); } catch (e) {} }
  }
  function closeDialog(d) {
    if (!d || d.hidden) return;
    d.hidden = true;
    unlock();
    if (d.__opener && d.__opener.focus) { try { d.__opener.focus({ preventScroll: true }); } catch (e) {} }
  }
  doc.addEventListener('click', function (e) {
    var o = e.target.closest('[data-pdpi-sg-open]');
    if (o) { e.preventDefault(); openDialog(doc.getElementById(o.getAttribute('data-pdpi-sg-open')), o); return; }
    var c = e.target.closest('[data-pdpi-sg-close]');
    if (c) { e.preventDefault(); closeDialog(c.closest('[data-pdpi-sg]')); return; }
    if (e.target.hasAttribute && e.target.hasAttribute('data-pdpi-sg')) closeDialog(e.target);
  });
  window.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    if (lb) { closeLightbox(); e.stopPropagation(); return; }
    var open = qsa('[data-pdpi-sg]').filter(function (d) { return !d.hidden; });
    if (open.length) { open.forEach(closeDialog); e.stopPropagation(); }
  }, true);

  /* ---------- Recently viewed ---------- */
  var KEY = 'alba-recent';
  function readRecent() {
    try {
      var v = JSON.parse(window.localStorage.getItem(KEY) || '[]');
      return Array.isArray(v) ? v.filter(function (h) { return typeof h === 'string' && h; }) : [];
    } catch (e) { return []; }
  }
  function writeRecent(list) {
    try { window.localStorage.setItem(KEY, JSON.stringify(list.slice(0, 12))); } catch (e) {}
  }
  function recordView() {
    var el = qs('[data-pdpi-record]');
    var h = el && el.getAttribute('data-pdpi-record');
    if (!h) return;
    var list = readRecent().filter(function (x) { return x !== h; });
    list.unshift(h);
    writeRecent(list);
  }
  function renderRecent() {
    qsa('[data-pdpi-recent]').forEach(function (sec) {
      if (sec.__pdpi) return;
      sec.__pdpi = true;
      var current = sec.getAttribute('data-current');
      var limit = parseInt(sec.getAttribute('data-limit'), 10) || 5;
      // All stored handles (max 12) are fetched, so products that no longer exist don't take one of the visible slots.
      var handles = readRecent().filter(function (h) { return h !== current; });
      var grid = qs('[data-pdpi-recent-grid]', sec);
      if (!handles.length || !grid || !window.fetch) return;
      var base = (window.Alba && window.Alba.routes && window.Alba.routes.root) || '/';
      if (base.charAt(base.length - 1) !== '/') base += '/';
      Promise.all(handles.map(function (h) {
        return fetch(base + 'products/' + encodeURIComponent(h) + '?section_id=alba-pdp-i-card', { credentials: 'same-origin' })
          .then(function (r) { return r.ok ? r.text() : (r.status === 404 ? null : ''); })
          .catch(function () { return ''; });
      })).then(function (results) {
        var gone = [];
        results.forEach(function (html, k) {
          if (html === null) { gone.push(handles[k]); return; }
          if (!html) return;
          var tmp = doc.createElement('div');
          tmp.innerHTML = html;
          var item = qs('[data-pdpi-card]', tmp);
          // An unpublished or deleted product returns an empty section (status 200): forget its handle.
          if (!item) { gone.push(handles[k]); return; }
          if (grid.children.length < limit) grid.appendChild(item);
        });
        if (gone.length) writeRecent(readRecent().filter(function (h) { return gone.indexOf(h) === -1; }));
        if (grid.children.length) sec.hidden = false;
      });
    });
  }

  /* ---------- Testimonials carousel ("Wat klanten zeggen", Impulse/Flickity look) ----------
     Slides share one grid cell and are placed with --d (offset from the selected slide, in slide widths).
     Wrap-around for more than 3 slides, dots, drag/swipe (7 px threshold), arrow keys, adaptive height.
     Like Impulse: starts when it is 600 px from the viewport and moves to slide 2 after 1 s (more than 2 slides). */
  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  function setupTestimonials(vp) {
    if (vp.__pdpi) return;
    vp.__pdpi = true;
    var root = vp.closest('.pdpi-tm') || vp;
    var slides = qsa('[data-pdpi-tm-slide]', vp);
    var dots = qsa('[data-pdpi-tm-dot]', vp);
    var n = slides.length;
    if (n < 2) return;
    var wrap = vp.getAttribute('data-wrap') === 'true';
    var sel = 0, touched = false, clearJump = 0;
    var ds = slides.map(function (s) { return parseFloat(s.style.getPropertyValue('--d')) || 0; });
    function offset(i) {
      var d = i - sel;
      if (wrap) { var half = Math.floor(n / 2); d = ((d % n) + n) % n; if (d > half) d -= n; }
      return d;
    }
    function fitHeight() {
      var s = slides[sel], h = s ? s.getBoundingClientRect().height : 0;
      if (h) vp.style.height = Math.round(h * 100) / 100 + 'px';
    }
    function render(animate) {
      slides.forEach(function (s, i) {
        var d = offset(i);
        if (!animate || Math.abs(d - ds[i]) > 1) s.classList.add('is-jump');
        s.style.setProperty('--d', d);
        ds[i] = d;
        var on = i === sel;
        s.classList.toggle('is-selected', on);
        if (on) s.removeAttribute('aria-hidden'); else s.setAttribute('aria-hidden', 'true');
      });
      dots.forEach(function (d, i) { d.classList.toggle('is-selected', i === sel); if (i === sel) d.setAttribute('aria-current', 'true'); else d.removeAttribute('aria-current'); });
      fitHeight();
      cancelAnimationFrame(clearJump);
      clearJump = requestAnimationFrame(function () { clearJump = requestAnimationFrame(function () { slides.forEach(function (s) { s.classList.remove('is-jump'); }); }); });
    }
    function go(i, animate) {
      i = wrap ? ((i % n) + n) % n : Math.max(0, Math.min(n - 1, i));
      sel = i;
      render(animate !== false && !reduceMotion);
    }
    vp.__pdpiGo = function (i) { touched = true; go(i); };
    dots.forEach(function (d, i) { d.addEventListener('click', function (e) { e.preventDefault(); touched = true; go(i); }); });
    vp.addEventListener('keydown', function (e) {
      if (e.target !== vp) return;
      if (e.key === 'ArrowLeft') { e.preventDefault(); touched = true; go(sel - 1); }
      else if (e.key === 'ArrowRight') { e.preventDefault(); touched = true; go(sel + 1); }
    });
    var drag = null;
    vp.addEventListener('pointerdown', function (e) {
      if ((e.pointerType === 'mouse' && e.button !== 0) || e.target.closest('[data-pdpi-tm-dot], a, button, input')) return;
      drag = { id: e.pointerId, x: e.clientX, y: e.clientY, t: Date.now(), dx: 0, on: false };
    });
    vp.addEventListener('pointermove', function (e) {
      if (!drag || e.pointerId !== drag.id) return;
      var mx = e.clientX - drag.x, my = e.clientY - drag.y;
      if (!drag.on) {
        if (Math.abs(mx) < 7 && Math.abs(my) < 7) return;
        if (Math.abs(my) > Math.abs(mx)) { drag = null; return; }
        drag.on = true; touched = true;
        try { vp.setPointerCapture(e.pointerId); } catch (er) {}
        root.classList.add('is-dragging');
      }
      drag.dx = mx;
      vp.style.setProperty('--dx', mx + 'px');
      e.preventDefault();
    });
    function endDrag(e) {
      if (!drag || (e && e.pointerId !== drag.id)) return;
      var d = drag; drag = null;
      if (!d.on) return;
      root.classList.remove('is-dragging');
      vp.style.removeProperty('--dx');
      var w = slides[sel].offsetWidth || vp.offsetWidth || 1;
      var fast = Math.abs(d.dx) > 20 && Date.now() - d.t < 300;
      if (d.dx < -w / 4 || (fast && d.dx < 0)) go(sel + 1);
      else if (d.dx > w / 4 || (fast && d.dx > 0)) go(sel - 1);
      else go(sel);
    }
    vp.addEventListener('pointerup', endDrag);
    vp.addEventListener('pointercancel', endDrag);
    vp.addEventListener('lostpointercapture', endDrag);
    vp.addEventListener('dragstart', function (e) { e.preventDefault(); });
    var lastW = window.innerWidth;
    window.addEventListener('resize', function () { if (window.innerWidth !== lastW) { lastW = window.innerWidth; fitHeight(); } });
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(fitHeight);
    render(false);
    if (n > 2) setTimeout(function () { if (!touched) go(1); }, 1000);
  }
  function initTestimonials(vp) {
    if (vp.__pdpiWatch) return;
    vp.__pdpiWatch = true;
    if (!('IntersectionObserver' in window) || (window.Shopify && window.Shopify.designMode)) { setupTestimonials(vp); return; }
    var io = new IntersectionObserver(function (en) {
      if (en.some(function (x) { return x.isIntersecting; })) { io.disconnect(); setupTestimonials(vp); }
    }, { rootMargin: '0px 0px 600px 0px' });
    io.observe(vp);
  }
  doc.addEventListener('shopify:block:select', function (e) {
    var slide = e.target && e.target.closest && e.target.closest('[data-pdpi-tm-slide]');
    var vp = slide && slide.closest('[data-pdpi-tm]');
    if (!vp) return;
    setupTestimonials(vp);
    if (vp.__pdpiGo) vp.__pdpiGo(parseInt(slide.getAttribute('data-pdpi-tm-slide'), 10) || 0);
  });

  /* ---------- Large image with text: text rises in when visible, parallax 15 % (Impulse formulas) ---------- */
  function initHero(el) {
    if (el.__pdpi) return;
    el.__pdpi = true;
    var editor = window.Shopify && window.Shopify.designMode;
    if (reduceMotion || editor || !('IntersectionObserver' in window)) el.classList.add('is-static');
    else {
      var show = function () { el.classList.add('is-loaded'); window.removeEventListener('scroll', check); };
      var check = function () { var r = el.getBoundingClientRect(); if (r.top < window.innerHeight && r.bottom > 0) { io.disconnect(); show(); } };
      var io = new IntersectionObserver(function (en) { if (en.some(function (x) { return x.isIntersecting; })) { io.disconnect(); show(); } });
      io.observe(el);
      window.addEventListener('scroll', check, { passive: true });
    }
    var img = qs('[data-pdpi-parallax]', el);
    if (!img || img.hasAttribute('data-off') || reduceMotion || editor) return;
    var box = img.parentNode, active = false, timer = null;
    function update() {
      var mp = Math.ceil((box.offsetHeight || 0) * 0.15 / 0.85);
      img.style.height = 'calc(100% + ' + mp + 'px)';
      var r = img.getBoundingClientRect(), vh = window.innerHeight;
      var p = (vh - r.top) / (vh + r.height);
      if (p > -0.1 && p < 1.1) img.style.transform = 'translate3d(0, ' + (-Math.min(Math.max(p, 0), 1) * mp).toFixed(2) + 'px, 0)';
      if (active) requestAnimationFrame(update);
    }
    function onScroll() {
      if (active) clearTimeout(timer); else { active = true; requestAnimationFrame(update); }
      timer = setTimeout(function () { active = false; }, 20);
    }
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll);
    update();
  }

  /* ---------- Quick view = the product page's own main blocks ----------
     Curvd's (Impulse) quick view renders the blocks of the product's own page. product.quick.liquid cannot read the
     product template's block settings, so for products whose page uses alba-main-product (data-pdpi-src) the info column
     is taken from that page itself: the same blocks, "Toon aan klanten" switches, placeholders and real data (the page is
     rendered for the viewer, so hidden blocks stay hidden). The quick-view root is replaced by a fresh copy, because
     alba-theme.js already bound its form to the first one; window.Alba.initProductMain then binds the new form.
     Until then the info column stays transparent (.is-loading, no jump); without a usable answer within 4 s the
     generated content of product.quick.liquid stays. The first read of a product template takes the whole page; the
     main section's id is then remembered per theme + template (data-pdpi-tpl), so later quick views only render that
     section (Section Rendering API: about 45 KB instead of 240 KB, no layout). An unknown id (404) falls back to the page. */
  var SID_KEY = 'alba-qv-sid';
  function sidMap() {
    try {
      var m = JSON.parse(window.localStorage.getItem(SID_KEY) || '{}');
      return m && typeof m === 'object' ? m : {};
    } catch (e) { return {}; }
  }
  function setSid(tpl, sid) {
    if (!tpl) return;
    try {
      var m = sidMap();
      if (sid) m[tpl] = sid; else delete m[tpl];
      window.localStorage.setItem(SID_KEY, JSON.stringify(m));
    } catch (e) {}
  }
  var pdpPages = {};
  function loadPdp(url) {
    if (!pdpPages[url]) {
      pdpPages[url] = fetch(url, { credentials: 'same-origin' }).then(function (r) {
        if (!r.ok) throw new Error('HTTP ' + r.status);
        return r.text();
      });
      pdpPages[url].catch(function () { delete pdpPages[url]; });
    }
    return pdpPages[url];
  }
  function swapQuickInfo(root, info) {
    var form = qs('form[data-product-form]', info);
    var sid = ((form && form.getAttribute('id')) || '').replace(/^ProductForm-/, '');
    var uid = root.getAttribute('data-pdpi-uid') || 'qv';
    var html = info.innerHTML;
    if (sid) html = html.split('ProductForm-' + sid).join('ProductForm-qv').split(sid).join(uid);
    var fresh = root.cloneNode(false);
    while (root.firstChild) fresh.appendChild(root.firstChild);
    var box = qs('.pdpi__info', fresh);
    if (!box) throw new Error('no info column');
    box.innerHTML = html;
    qsa('[data-shopify-editor-block]', box).forEach(function (el) { el.removeAttribute('data-shopify-editor-block'); });
    qsa('h1', box).forEach(function (h) {
      var el = doc.createElement('p');
      el.className = h.className;
      el.innerHTML = h.innerHTML;
      h.parentNode.replaceChild(el, h);
    });
    fresh.setAttribute('data-pdpi-from', 'page');
    root.parentNode.replaceChild(fresh, root);
    return fresh;
  }
  function quickFromPdp(root) {
    var finished = false, timer = null;
    function finish(info) {
      if (finished) return;
      finished = true;
      clearTimeout(timer);
      if (!root.isConnected) return;
      var target = root;
      if (info) {
        try { target = swapQuickInfo(root, info); }
        catch (e) { target = root.isConnected ? root : null; }
      }
      if (!target) return;
      target.__pdpiReady = true;
      initRoot(target);
      requestAnimationFrame(function () { target.classList.remove('is-loading'); });
    }
    timer = setTimeout(function () { finish(null); }, 4000);
    var src = root.getAttribute('data-pdpi-src');
    var handle = root.getAttribute('data-pdpi-handle');
    var t = root.getAttribute('data-pdpi-tpl');
    var tpl = t === null ? '' : ((window.Shopify && window.Shopify.theme && window.Shopify.theme.id) || '') + ':' + t;
    var sid = tpl ? sidMap()[tpl] : null;
    if (typeof sid !== 'string' || !/^[\w-]+$/.test(sid)) sid = null;
    var first = sid
      ? loadPdp(src + (src.indexOf('?') === -1 ? '?' : '&') + 'section_id=' + encodeURIComponent(sid))
          .then(function (html) { return pickInfo(html, handle); }, function () { return null; })
      : Promise.resolve(null);
    first.then(function (info) {
      if (info) return info;
      if (sid) setSid(tpl, null);
      return loadPdp(src).then(function (html) {
        var i = pickInfo(html, handle);
        var f = i && qs('form[data-product-form]', i);
        var id = f ? (f.getAttribute('id') || '').replace(/^ProductForm-/, '') : '';
        if (id) setSid(tpl, id);
        return i;
      });
    }).then(function (info) { finish(info); }, function () { finish(null); });
  }
  function pickInfo(html, handle) {
    var page = new DOMParser().parseFromString(html, 'text/html');
    var main = qsa('[data-pdpi-record]', page).filter(function (m) { return m.getAttribute('data-pdpi-record') === handle; })[0];
    var info = main && qs('.pdpi__info', main);
    return info && qs('form[data-product-form] [data-atc]', info) ? info : null;
  }

  /* ---------- Init ---------- */
  function initRoot(root) {
    if (root.__pdpiInit) return;
    if (root.hasAttribute('data-pdpi-src') && !root.__pdpiReady) {
      if (!root.__pdpiLoading) { root.__pdpiLoading = true; quickFromPdp(root); }
      return;
    }
    root.__pdpiInit = true;
    if (window.Alba && typeof window.Alba.initProductMain === 'function') window.Alba.initProductMain(root);
    initGallery(root);
    updateAvailability(root);
  }
  function scan() {
    qsa('[data-pdpi]').forEach(initRoot);
    qsa('[data-pdpi-tm]').forEach(initTestimonials);
    qsa('[data-pdpi-hero]').forEach(initHero);
    renderRecent();
  }
  // Theme editor: sections are re-rendered without running their scripts.
  doc.addEventListener('shopify:section:load', function () { scan(); });
  window.AlbaPdpi = { scan: scan, updateAvailability: updateAvailability };

  recordView();
  scan();
  var qv = doc.getElementById('QuickViewModal');
  if (qv && window.MutationObserver) {
    new MutationObserver(function () { qsa('[data-pdpi]', qv).forEach(initRoot); }).observe(qv, { childList: true, subtree: true });
  }
})();
